import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ActionName } from './month-picker.constants';
import { ParentComponent } from '@app/shared/constants/parent-component';
import { Routes } from '@app/constants/routes.constants';
import { CORRECT_MONTH_NUMBER } from '@app/shared/constants/timesheet.constants';
import { AuthDOS } from '@app/auth/services/auth-dos.service';
import { TimesheetDates } from '@app/timesheet-user/services/timesheet-service.constants';
import { MonthPickerDOS } from './month-picker-dos.service';

@Injectable({
  providedIn: 'root'
})
export class MonthPickerService {
  constructor(private _router: Router, private _authDOS: AuthDOS, private _monthPickerDOS: MonthPickerDOS) {}

  setNewMonth(parentComponent: string, currentSetMonth: Date, monthChangeType: string, chosenMonth: Date = null): void {
    const [newSetYear, newSetMonth] = this.setMonth(monthChangeType, currentSetMonth, chosenMonth);

    switch (parentComponent) {
      case ParentComponent.Timesheet:
        this._router.navigate([Routes.Timesheet, newSetYear, newSetMonth + CORRECT_MONTH_NUMBER]);
        break;
      case ParentComponent.MonthlyReport:
        this._router.navigate([Routes.MonthlyReport, newSetYear, newSetMonth + CORRECT_MONTH_NUMBER]);
        break;
    }
  }

  setMonth(monthChangeType: string, currentSetMonth: Date, chosenMonth: Date = null): [number, number] {
    const currentMonthNumber = currentSetMonth ? currentSetMonth.getMonth() : null;
    const newDate = currentSetMonth;
    newDate.setDate(1);

    switch (monthChangeType) {
      case ActionName.MonthChange:
        this._monthPickerDOS.changeSelectedReleaseMonth(this.areSelectedAndReleaseDateEqual(chosenMonth));

        return [chosenMonth.getFullYear(), chosenMonth.getMonth()];
      case ActionName.Decrement: {
        newDate.setMonth(currentMonthNumber - TimesheetDates.NUMBER_OF_MONTHS_CHANGED);
        this._monthPickerDOS.changeSelectedReleaseMonth(this.areSelectedAndReleaseDateEqual(newDate));

        return [newDate.getFullYear(), newDate.getMonth()];
      }
      case ActionName.Increment: {
        newDate.setMonth(currentMonthNumber + TimesheetDates.NUMBER_OF_MONTHS_CHANGED);
        this._monthPickerDOS.changeSelectedReleaseMonth(this.areSelectedAndReleaseDateEqual(newDate));

        return [newDate.getFullYear(), newDate.getMonth()];
      }
    }
  }

  areSelectedAndReleaseDateEqual(selectedDate: Date): boolean {
    const releaseDate = this._authDOS.getReleaseDateSnapshot();

    return (
      releaseDate.getMonth() === selectedDate.getMonth() && releaseDate.getFullYear() === selectedDate.getFullYear()
    );
  }
}
